import { useContext, useEffect, memo } from "react";
import Loading from "../../../components/basics/Loading";
import HeaderModule from "../../../components/header/HeaderModule";
import ModalContracts from "./children/ModalContracts";
import {
  TemplateContractsContext,
  TemplateContractsContextProvider,
} from "./contexts/ContractsContext";
import { Margin } from "../../../theme/styles/Utils";
import { Container, Grid } from "@material-ui/core";
import { Line } from "./styles/ModalContracts";
import Btn from "../../../components/buttons/Btn";
import ContractsController from "./controller/ContractsController";
import { useHistory } from "react-router-dom";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import AcordionContractsGeral from "./children/AcordionContractsGeral";
import AcordionContractsCompany from "./children/AcordionContractsCompany";
import { useMemo } from "react";
import { GlobalVariables } from "../../../GlobalVariables";

const View = ({ location }) => {
  const { mainLoading, setMainLoading, setDisabledEditor, showCompanies } =
    useContext(TemplateContractsContext);
  const { initHeandleInputs, store, destroy, clearContext } =
    ContractsController();
  const { push } = useHistory();
  const { queryParams } = useContext(QueryParamsContext);

  const handleSave = async () => {
    setMainLoading(true);

    await store();

    setMainLoading(false);
  };

  const handleDestroy = async () => {
    if (location?.state?.item?.id) await destroy(location?.state?.item?.id);

    push("listagem");
    clearContext();
  };

  useEffect(() => {
    if (location?.state?.item) {
      setDisabledEditor(true);
    }
  }, [location, setDisabledEditor]);

  useEffect(() => {
    if (queryParams?.empresa_cnpj)
      initHeandleInputs(
        location?.state?.item?.id,
        location?.state?.item?.cloned
      );
  }, [queryParams?.empresa_cnpj, location.state?.item, initHeandleInputs]);

  return (
    <>
      <Loading open={mainLoading} />
      <HeaderModule
        title="CADASTRO DE CONTRATOS DE SERVIÇOS"
        videoId={GlobalVariables.screenVideosIds.cadastroGeradorContratos}
      />
      <Margin top="100">
        <Container maxWidth="xl">
          <AcordionContractsGeral location={location} />
          {showCompanies && <AcordionContractsCompany location={location} />}
          <ModalContracts location={location} />
          <Line container />
          <Line container spacing={2} justifyContent="flex-end">
            <Grid item xs={1}>
              <Btn
                label="EXCLUIR"
                onClick={handleDestroy}
                fullWidth={true}
                bgcolor="darkred"
                disabled={
                  !location?.state?.item?.id || location?.state?.item?.id === 1
                }
              />
            </Grid>
            <Grid item xs={1}>
              <Btn
                label="SALVAR"
                onClick={handleSave}
                fullWidth={true}
                bgcolor="primary"
              />
            </Grid>
            <Grid item xs={1}>
              <Btn
                label="CANCELAR"
                onClick={() => {
                  push("listagem");
                  clearContext();
                }}
                fullWidth={true}
                bgcolor="grey"
              />
            </Grid>
          </Line>
        </Container>
      </Margin>
    </>
  );
};

const ContractsCadastro = ({ ...props }) => {
  const memoView = useMemo(() => <View {...props} />, [props]);

  return (
    <TemplateContractsContextProvider>
      {memoView}
    </TemplateContractsContextProvider>
  );
};

export default memo(ContractsCadastro);
